import { Progress, ProgressProps } from '@mantine/core';
import { forwardRef } from 'react';

/** @deprecated Use `Progress` from `@zorro/design-system/v2/Progress` instead */
export type IProgressProps = ProgressProps;
/** @deprecated Use `Progress` from `@zorro/design-system/v2/Progress` instead */
export const ZorroProgress = forwardRef<HTMLDivElement, IProgressProps>(
  ({ ...props }, ref) => {
    return <Progress ref={ref} {...props} />;
  }
);

ZorroProgress.displayName = 'ZorroProgress';
